module.exports = __webpack_public_path__ + "img/Mask Group 40.01a25e3d.svg";